import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../firebase";
import { doc, getDoc, getFirestore } from "firebase/firestore";
import { db } from "../firebase";
import "../css/dash.css";
import MenuComp from "../comps/menuComp";
import CreateMenuButton from "../comps/New";
import Qrcode from "../comps/Qrcode";
import getSubscriptionStatus from "../backend/getsub.js";
export default function Dashboard() {
  const [user, setUser] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [menus, setMenus] = useState([]);
  const [subLevel, setSubLevel] = useState();
  const nav = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (!currentUser) {
        nav("/");
      } else {
        getUserData(currentUser.uid);
      }
    });
    return () => unsubscribe();
  }, [nav]);
  const getUserData = async (uid) => {
    const userdocRef = doc(db, "users", uid);
    const data = await getDoc(userdocRef);
    setUser(data.data());
    const subData = await getSubscriptionStatus();
    setSubLevel(subData.level);
    if(subData.active != true){
        nav("/checkout");
    }
    if(data.data().menus.length != 0){
      loadMenus(data.data());
    }
  };
 const loadMenus = async (user) => {
  try {
    if (!user?.menus || user.menus.length === 0) {
      setMenus([]); // No menus yet
      return;
    }

    const menuData = await Promise.all(
      user.menus.map(async (menuId) => {
        const menuDocRef = doc(db, "menus", menuId);
        const snapshot = await getDoc(menuDocRef);
        if (snapshot.exists()) {
          return { id: menuId, ...snapshot.data() };
        } else {
          console.warn(`Menu not found for ID: ${menuId}`);
          return null; // Prevent undefined in array
        }
      })
    );

    // Filter out nulls for missing/deleted menus
    setMenus(menuData.filter(Boolean));
  } catch (e) {
    console.error("Error loading menu data:", e);
    alert("There was an error getting menu data");
  }
};
  const handleLogout = async () => {
    await signOut(auth);
    nav("/");
  };

  if (!user) {
    return (
      <div className="loadingContainer">
        <div className="loader"></div>
        <h2>Loading your dashboard...</h2>
      </div>
    );
  }

  return (
    <section className="dashboard">
      {/* Sidebar */}
      <aside className={`sidebar ${menuOpen ? "open" : ""}`}>
        <h3 className={"closeSideBar"}onClick={() => setMenuOpen(false)}>X</h3>
        <h2 className="logo">MenuLinker</h2>
        <nav>
          <ul>
            <li className="active">Dashboard</li>
            <li onClick={() => nav("/analytics")}>Analytics</li>
            <li onClick={() => nav("/settings")}>Settings</li>
            <li><a href="mailto:tglewis247@gmail.com">Contact</a></li>
          </ul>
        </nav>
        <button className="logoutBtn" onClick={handleLogout}>
          Log out
        </button>
      </aside>

      {/* Main */}
      <main className="mainContent">
        <header className="dashHeader">
          <button className="menuToggle" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </button>
          <div>
            <h1>Hello, {user.name} 👋 <a style={{backgroundColor: "#3dc0daff", padding: 5, borderRadius: 10}}>{subLevel}</a></h1>
            <p>Welcome back to your MenuLinker dashboard</p>
          </div>
        </header>

        <section className="cardsGrid">
          <div className="card">
            <h3>Menus</h3>
            {menus.map((menu) =>{
                return(<MenuComp menu={menu} user={user} level={subLevel}/>)
            })}
           
              <CreateMenuButton/>
              
           
          

  
          
          </div>
          <div className="card">
              <h3>Qr Codes</h3>
               {menus.map((menu) =>{
                return(
  
                  <Qrcode menu={menu}/>
                 
              )
              })}
          </div>
        </section>
      </main>
    </section>
  );
}
